import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from "../actions/api"; 

export const fetchAppointmentTrends = createAsyncThunk(
  'appointments/fetchAppointmentTrends',
  async (_, { rejectWithValue }) => {
    try {
      const res = await api({ auth: true }).get('/clinic/dashboard/appointments');
      return res.data.data; 
        } catch (error) {
      return rejectWithValue(error?.response?.data || 'Failed to fetch appointment data');
    }
  }
);

const initialState = {
  yearlyData: [],
  weeklyData: {},
  dailyData: {},
  loading: false,
  error: null,
};

const appointmentSlice = createSlice({
  name: 'appointments',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchAppointmentTrends.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAppointmentTrends.fulfilled, (state, action) => {
        state.loading = false;
        state.yearlyData = action.payload.appointmentTrends || {};
        state.weeklyData = action.payload.appointmentTrendWeeks || {};
        state.dailyData = action.payload.appointmentTrendDay || {};
      })
      .addCase(fetchAppointmentTrends.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default appointmentSlice.reducer;